<template>
  <BaseElTableColumn
    :prop="column.prop"
    :label="column.label"
    :align="column.align || 'center'"
    :fixed="column.fixed"
    :width="column.width"
    :type="column.type"
  >
    <template slot-scope="scope">
      <component
        :is="column.component || 'div'"
        v-bind="typeof column.props === 'function' ? column.props(scope.row) : column.props"
        v-on="typeof column.on === 'function' ? column.on(scope.row) : column.on"
      >
        <div v-if="column.render">{{ column.render(scope.row) }}</div>
      </component>
    </template>
  </BaseElTableColumn>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'BobTableColumn',
  props: {
    column: {
      type: Object,
      required: true,
    },
  },
  setup (props, { emit }) {
    return {}
  },
})
</script>

<style lang="postcss" scoped>

</style>
